import React from 'react';
import propTypes from 'prop-types';
import { Route, Switch } from 'react-router';
import { Miss, importComponent } from '@xingternal/hops';
import { LastLocationProvider } from 'react-router-last-location';

import { RedirectToDemo } from './components/RedirectToDemo';
import AuthenticatedRoute from './components/AuthenticatedRoute';

import Layout from './Layout';

import { DialogContextProvider } from '@xingternal/pages-common';

const CompanyPageCreation = importComponent(
  () => import('./components/CompanyPageCreation')
);

const Edit = importComponent(() => import('./components/Edit'));

const MainPage = importComponent(() => import('./components/MainPage'));

const SubPage = importComponent(() => import('./components/Subpage'));

const Routes = () => (
  <Route path="/">
    <LastLocationProvider>
      <Switch>
        <AuthenticatedRoute
          exact
          path="/pages/new/company"
          component={CompanyPageCreation}
        />
        <Route
          path="/pages/:slug/demo"
          render={(props) => <RedirectToDemo {...props} />}
        />
        <Route
          path={['/pages/webview/:slug/edit/:item']}
          render={(props) => (
            <DialogContextProvider>
              <Layout isWebview={true}>
                <Edit
                  isWebview={true}
                  pageSlug={props.match.params.slug}
                  {...props}
                />
              </Layout>
            </DialogContextProvider>
          )}
        />
        <Route
          path={[
            '/pages/webview/:slug/:type/:param',
            '/pages/webview/:slug/:type',
          ]}
          render={(props) => (
            <Layout isWebview={true}>
              <SubPage
                pageSlug={props.match.params.slug}
                isWebview={true}
                {...props}
              />
            </Layout>
          )}
        />
        <Route
          path={['/pages/:slug/edit/:item']}
          render={(props) => (
            <DialogContextProvider>
              <Layout isZenView={true}>
                <Edit pageSlug={props.match.params.slug} {...props} />
              </Layout>
            </DialogContextProvider>
          )}
        />
        <Route
          path={['/pages/:slug/:type/:param']}
          render={(props) => (
            <Layout>
              <SubPage pageSlug={props.match.params.slug} {...props} />
            </Layout>
          )}
        />
        <Route
          path={['/pages/:slug/:type']}
          render={(props) => (
            <Layout>
              <SubPage pageSlug={props.match.params.slug} {...props} />
            </Layout>
          )}
        />
        <Route
          path={['/pages/:slug']}
          render={(props) => (
            <Layout isMainPage>
              <MainPage pageSlug={props.match.params.slug} {...props} />
            </Layout>
          )}
        />
        <Miss />
      </Switch>
    </LastLocationProvider>
  </Route>
);

Routes.propTypes = {
  match: propTypes.object,
};

export default Routes;
